export default {
    login: {
        title: 'NFC Smart Business Card',
        welcome: 'Welcome to log in',
        code: 'Code',
        send: 'Send verification code',
        info: 'EDIT PERSONAL INFORMATION',
        avatar: 'Head portrait',
        name: 'Name',
        nameplaceholder: 'Enter your name',
        englishName: 'English name',
        englishnameplaceholder: 'Enter your English name',
        position: 'Position',
        englishposition: 'English name of the position',
        visitLinkUrl: 'Enterprise WeChat link',
        getvis: 'Get Tutorial',
        visitplaceholder: 'Enter the enterprise WeChat link',
        moblie: 'Moblie',
        moblieplaceholder: 'Enter your phone number',
        email: 'Email',
        emailplaceholder: 'Enter your email',
        model1: 'Display model',
        model2: 'Display model',
        loginout: 'Log out',
        confirm: 'Confirm',
        codeplaceholder: 'Enter the verification code',
        noman: "You don't have a digital person yet, please set up a digital person first",
        phonemes: 'Enter the correct phone number format',
        num: 'Retrieve again later',
        filemes: 'The file format is incorrect',
        sizemes: 'The file is too large, please upload a file smaller than 10MB',
        fillin: 'Fill in contact information',
        edit: 'EDIT PERSONAL INFORMATION'
    },
    home: {
        persentitle: 'Personal Information',
        set: 'Digital person',
        edit: 'Edit',
        call: 'Contact Information',
        look: 'Preview',
        return: 'Return',
        copy: 'Copy link',
        copyemail: 'Email copied to clipboard',
        copymes: 'Copy failed, please manually copy',
        copyphone: 'The phone number has been copied to the clipboard',
        email: 'E-mail',
        emailcopy: 'One click Copy Email',
        phone: 'Phone number',
        phonecopy: 'One click add phone number',
        link: 'WeCom',
        linkcopy: 'One click jump to add friend page'
    },
    person: {
        title: 'Digital person',
        num: 'No',
        time: 'Expected completion time',
        fintime: 'Completion time',
        redo: 'Redo',
        look: 'Preview',
        add: 'Add digital person',
        remaining: 'Remaining',
        times: "time",
        mes: 'Generating, unable to preview',
        mes2: 'Resubmit successfully',
        sta1: 'Generated',
        sta2: 'Generating',
        sta3: 'Generation failed',
        timeover: 'The number of times a digital person has been created has been used up',
        change: 'Choose card style',
        upload: 'Upload photos and sound quality',
        picture: 'Photo',
        tips: 'Upload prompt',
        tips1: 'Size less than 10MB',
        tips2: 'Clear and unobstructed facial features',
        tips3: 'Try to use half body photos as the display effect is relatively poor if the head proportion is too large.',
        audio: 'Record a speech to train AI',
        audiotips1: 'You can freely express yourself or record the following content for no less than 10 seconds',
        audiotips2: "Start recording. Hello, I am [your name]. Next, I will read you the training text for the speech model. At this moment, the sky outside the window is a peaceful blue, and a few white clouds are slowly drifting by. The technology of artificial intelligence is quietly changing the way we live and work, and it is full of infinite potential and opportunities.",
        hold: 'Press and hold the recording',
        finshup: 'Completed recording and sampling',
        redo2: 'Rerecording',
        text: 'Enter numbers to broadcast text',
        textplaceholder: "Please enter the content you need AI to broadcast, no more than 200 words",
        textcopy: 'Paste Enterprise Broadcast Template',
        next: 'Next step',
        start: 'Start generating',
        sizemes: 'The file is too large, please upload a file smaller than 2MB',
        uploadmes: 'Less than 10 seconds, please re record',
        uploadmes2: 'No recording data available',
        uploadmes3: 'The recording data is too short, please record for at least 10 seconds',
        uploadmes4: 'Upload successful',
        uploadmes5: 'Unable to proceed to the next step due to incomplete upload',
        use: 'Use',
        lookperson: 'Preview digital person',
        lookmes: 'Successfully used'
    }

}